module.exports = __webpack_public_path__ + "img/logo2.f4fdd908.png";